<template>
  <div class="app">
    <main-nav v-if="loggedIn"></main-nav>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex";
import MainNav from "@/components/common/nav/MainNav.vue";

export default {
  components: {
    MainNav,
  },
  computed: {
    ...mapState({
      loggedIn: (state) => state.loggedIn,
    }),
  },
};
</script>
<style lang="scss" scoped>
.app {
  height: 100%;
}
</style>